import { render, staticRenderFns } from "./InicioDiretor.vue?vue&type=template&id=22909d22&"
import script from "./InicioDiretor.vue?vue&type=script&lang=js&"
export * from "./InicioDiretor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports